// Modules
import { Tooltip as AntTooltip } from "antd";
import { TooltipProps as AntTooltipProps } from "antd/es/tooltip";

// Styles
import styles from "components/atoms/Tooltip/Tooltip.module.css";

// Type definitions
export type TooltipProps = {
	title: string;
	placement?: AntTooltipProps["placement"];
	color?: string;
	textColor?: string;
	children: React.ReactNode;
};

const Tooltip = ({ title, placement, color, textColor, children }: TooltipProps): JSX.Element => {
	const overlayInnerStyle = {
		backgroundColor: color || "#ffffff",
		color: textColor || "#000000",
		borderRadius: "6px",
		fontSize: "14px",
		lineHeight: "1.5"
	};

	const tooltipColor = color || "#ffffff";

	return (
		<AntTooltip title={title} placement={placement} overlayInnerStyle={overlayInnerStyle} overlayClassName={styles.tooltip} color={tooltipColor}>
			{children}
		</AntTooltip>
	);
};

export default Tooltip;
